/* unplugin-vue-components disabled */import { render } from "./TestInstructions.vue?vue&type=template&id=9da7c5da"
import script from "./TestInstructions.vue?vue&type=script&lang=js"
export * from "./TestInstructions.vue?vue&type=script&lang=js"

import "./TestInstructions.vue?vue&type=style&index=0&id=9da7c5da&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__